import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";
import { IconDisplayComponent } from "@ui/ui-helpers/display-formats/icon-display/icon-display.component";
import { NotificationItemComponent } from "./notification-item/notification-item.component";
import { NotificationEvent } from "./notification-item/types";

@Component({
  selector: "lc-notifications-panel",
  templateUrl: "./notifications-panel.component.html",
  styleUrl: "./notifications-panel.component.scss",
  imports: [IconDisplayComponent, NotificationItemComponent, TranslatePipe],
})
export class NotificationsPanelComponent {
  @Input() public notifications: NotificationEvent[] = [];
  @Output() public closePanelEvent = new EventEmitter<void>();
  @Output() public markNotificationAsReadEvent =
    new EventEmitter<NotificationEvent>();

  closePanel(): void {
    this.closePanelEvent.emit();
  }

  markNotificationAsRead(notification: NotificationEvent): void {
    this.markNotificationAsReadEvent.emit(notification);
  }
}
